import React from 'react';
import cx from 'classnames';
import { Form } from '@ant-design/compatible';
import ProductExternalChannel from '../../common/form/ProductExternalChannel';
import ProductDetailStatus from '../ProductDetailStatus';
import ProductCategory from '../../common/form/ProductCategory';
import ProductProperty from '../../common/form/ProductProperty';
import ProductNameAndPrice from '../../common/form/ProductNameAndPrice';
import ProductStockAndOption from '../../common/form/ProductStockAndOption';
import ProductPayMethod from '../../common/form/ProductPayMethod';
import ProductTagInfo from '../../common/form/ProductTagInfo';
import ProductImg from '../../common/form/ProductImg';
import ProductDescriptionImg from '../../common/form/ProductDescriptionImg';
import ProductDeliveryInfo from '../../common/form/ProductDeliveryInfo';
import ProductAfterService from '../../common/form/ProductAfterService';

const ProductVersionSection = (props) => {
  const {
    form,
    className,
    sectionName,
    sectionId,
    productDetail,
    comparisonTarget,
    productPropertyList,
    scrollToTargetPanel,
  } = props;

  return (
    <div className={cx('section', className)}>
      <div className="title">{sectionName}</div>

      <div className="product-detail" id={sectionId}>
        {/* 상품 상태 */}
        <ProductDetailStatus
          sectionId={sectionId}
          isEditable={false}
          form={form}
          initialValue={productDetail.proStatus}
          isCompare={true}
          comparisonData={comparisonTarget.proStatus}
          scrollToTargetPanel={scrollToTargetPanel}
        />
        {/* 카테고리 */}
        <ProductCategory
          sectionId={sectionId}
          form={form}
          isEditable={false}
          initialValue={productDetail.proCategory}
          isCompare={true}
          comparisonData={comparisonTarget.proCategory}
          scrollToTargetPanel={scrollToTargetPanel}
        />
        {/* 상품 속성 */}
        <ProductProperty
          sectionId={sectionId}
          form={form}
          isEditable={false}
          productId={productDetail.productId}
          initialValue={productDetail.proInfo}
          propertyList={productPropertyList}
          isCompare={true}
          comparisonData={comparisonTarget.proInfo}
          scrollToTargetPanel={scrollToTargetPanel}
        />
        {/* 상품명/판매가 */}
        <ProductNameAndPrice
          sectionId={sectionId}
          form={form}
          isEditable={false}
          initialValue={productDetail.proNameAndPrice}
          isCompare={true}
          comparisonData={comparisonTarget.proNameAndPrice}
          scrollToTargetPanel={scrollToTargetPanel}
        />
        {/* 재고/옵션 */}
        <ProductStockAndOption
          sectionId={sectionId}
          form={form}
          isEditable={false}
          initialValue={productDetail.proStockAndOption}
          proInfo={productDetail.proInfo}
          isCompare={true}
          comparisonData={comparisonTarget.proStockAndOption}
          scrollToTargetPanel={scrollToTargetPanel}
        />
        {/* 상품 결제 */}
        <ProductPayMethod
          sectionId={sectionId}
          isEditable={false}
          form={form}
          initialValue={productDetail.proInfo}
          productPayMethodTypeInfo={productDetail.productPayMethodTypeInfo}
          isCompare={true}
          comparisonData={comparisonTarget.proInfo}
          scrollToTargetPanel={scrollToTargetPanel}
        />
        {/* 태그 정보 */}
        <ProductTagInfo
          sectionId={sectionId}
          isEditable={false}
          form={form}
          initialValue={productDetail.proInfo.productTagInfo}
          productTagInfo={productDetail.productTagInfo}
          isCompare={true}
          comparisonData={comparisonTarget.proInfo.productTagInfo}
          scrollToTargetPanel={scrollToTargetPanel}
        />
        {/* 상품 이미지 */}
        <ProductImg
          sectionId={sectionId}
          isEditable={false}
          form={form}
          initialValue={productDetail.proImg}
          isCompare={true}
          comparisonData={comparisonTarget.proImg}
          scrollToTargetPanel={scrollToTargetPanel}
        />
        {/* 상품 상세 설명 */}
        <ProductDescriptionImg
          sectionId={sectionId}
          isEditable={false}
          form={form}
          initialValue={productDetail.proDescriptionImg}
          isCompare={true}
          comparisonData={comparisonTarget.proDescriptionImg}
          scrollToTargetPanel={scrollToTargetPanel}
        />

        {/* 배송 정보 */}
        <ProductDeliveryInfo
          sectionId={sectionId}
          isEditable={false}
          form={form}
          initialValue={productDetail.proDeliveryInfo}
          isCompare={true}
          comparisonData={comparisonTarget.proDeliveryInfo}
          scrollToTargetPanel={scrollToTargetPanel}
        />
        {/* A/S 정보 */}
        <ProductAfterService
          sectionId={sectionId}
          isEditable={false}
          form={form}
          initialValue={productDetail.proAfterService}
          isCompare={true}
          comparisonData={comparisonTarget.proAfterService}
          scrollToTargetPanel={scrollToTargetPanel}
        />
        {/* 외부 채널 */}
        <ProductExternalChannel
          sectionId={sectionId}
          initialValue={productDetail.sentExternalChannel}
          isCompare={true}
          comparisonData={comparisonTarget.sentExternalChannel}
          scrollToTargetPanel={scrollToTargetPanel}
        />
      </div>
    </div>
  );
};

export default Form.create()(ProductVersionSection);
